<template>
	<div>
		<div class="first-top" :style="this.change == false?'top:90px':'top:200px' ">
			<item :icon="sidebarRouters[$store.state.topNav].meta.title && sidebarRouters[$store.state.topNav].meta.icon"
			 :title="$t(sidebarRouters[$store.state.topNav].meta.title)" />
		</div>
		<div></div>
		<div v-if="!item.hidden">
			<template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
				<!-- <app-link :to="item.path"> -->
					<el-menu-item :index="resolvePath(onlyOneChild.path)" @click="goPath(item.path)">
						<div class="navdot"></div>
						<item :title="$t(onlyOneChild.meta.title)" />
						<!-- :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" -->
					</el-menu-item>
				<!-- </app-link> -->
			</template>
			<el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" class="three_two" popper-append-to-body>
				<!-- 有三级目录的二级目录 -->
				<div slot="title"  class="two_nav">
					<div class="navdot" style="margin-left:24px;"></div>
					<item v-if="item.meta" :title="$t(item.meta.title)" />
					<!-- :icon="item.meta && item.meta.icon" -->
				</div>
				<!-- 三级目录 -->
				<div style="height:100%;position: relative;z-index: 99;" class="lefttwo left_three">
					<sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)"
					 class="nest-menu" />
				</div>
			</el-submenu>
			<!-- <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
				<template slot="title">
					<item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="$t(item.meta.title)" />
				</template>
				<sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)"
				 class="nest-menu" />
			</el-submenu> -->
			<!-- <div style="font-size:12px;">{{msg}}</div> -->
		</div>
	</div>
</template>

<script>
	import {mapGetters,mapState} from "vuex";
	import path from 'path'
	import {isExternal} from '@/utils/validate'
	import Item from './Item'
	import AppLink from './Link'
	import FixiOSBug from './FixiOSBug'
	import bus from './bus.js'

	export default {
		name: 'SidebarItem',
		components: {
			Item,
			AppLink
		},
		mixins: [FixiOSBug],
		props: {
			// route object
			item: {
				type: Object,
				required: true
			},
			isNest: {
				type: Boolean,
				default: false
			},
			basePath: {
				type: String,
				default: ''
			},
			change:{
				type:Boolean
			}
		},
		data() {
			this.onlyOneChild = null
			return {
				msg: '首页'
			}
		},
		methods: {
			// 菜单点击跳转
			goPath(path) {
        // modify by robort20220524毛工要求不限制
        this.$router.push(path);
				// let linkArr = this.$store.state.tagsView.visitedViews;
				// //在这判断 is  ok？
				// if(linkArr.length !== 0 && linkArr.length > 8) {
				// 	for(let i=0; i<linkArr.length; i++){
				// 		// console.log(linkArr[i].path);
				// 		// console.log(path);
				// 		if(linkArr[i].path == path){
				// 			this.$router.push(path);
				// 		}else{
				// 			this.msgError("标签页打开过多，请关闭一些再试");
				// 			return
				// 		}
				// 	}
				// }else{
				// 	this.$router.push(path);
				// }
			},
			hasOneShowingChild(children = [], parent) {
				const showingChildren = children.filter(item => {
					if (item.hidden) {
						return false
					} else {
						// Temp set(will be used if only has one showing child)
						this.onlyOneChild = item
						return true
					}
				})

				// When there is only one child router, the child router is displayed by default
				if (showingChildren.length === 1) {
					return true
				}

				// Show parent if there are no child router to display
				if (showingChildren.length === 0) {
					this.onlyOneChild = { ...parent,
						path: '',
						noShowingChildren: true
					}
					return true
				}

				return false
			},
			resolvePath(routePath) {
				if (isExternal(routePath)) {
					return routePath
				}
				if (isExternal(this.basePath)) {
					return this.basePath
				}
				return path.resolve(this.basePath, routePath)
			}
		},
		mounted() {
			var that = this;
			bus.$on("topname", function(msg) {
				that.msg = msg;
			})

		},
		computed: {
			...mapState(["settings"]),
			...mapGetters(["sidebarRouters", "sidebar"]),

		}
	}
</script>
<style scoped>
	.lefttwo .el-menu-item {
		background-color: #e4f3fb;
		padding-left: 44px !important;
	}

	.left_three .navdot {
		display: none;
	}

	.navdot {
		position: absolute;
		width: 5px;
		height: 5px;
		border-radius: 50%;
		border: 1px #1C81D9 solid;
		margin-top: 21px;
		color: rgb(37, 177, 247);
	}

	.el-menu-item {
		height: 45px;
		line-height: 45px;
	}

	.first-top {
		position: fixed;
		z-index: 100;
		width: 231px;
		background-color: #e4f3fb;
		top: 200px;
		padding-bottom: 20px;
	}

	.first-top span {
		margin-left: 10px !important;
	}

	.first-top span {
		font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑;
		font-weight: 700;
		color: #1C81D9;
	}

	.first-top svg {
		color: rgb(28, 129, 217);
		font-size: 20px;
	}

	.lefttwo .el-menu-item.is-active {
		color: #25B1F7 ;
		font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
		font-weight: 700;
		background: -webkit-linear-gradient(270deg, rgba(228, 243, 251, 1) 0%, rgba(228, 243, 251, 1) 42%, rgba(177, 224, 248, 1) 100%, rgba(177, 224, 248, 1) 100%);
		background: -moz-linear-gradient(180deg, rgba(228, 243, 251, 1) 0%, rgba(228, 243, 251, 1) 42%, rgba(177, 224, 248, 1) 100%, rgba(177, 224, 248, 1) 100%);
		background: linear-gradient(180deg, rgba(228, 243, 251, 1) 0%, rgba(228, 243, 251, 1) 42%, rgba(177, 224, 248, 1) 100%, rgba(177, 224, 248, 1) 100%);
		border-radius: 0px;
		-moz-box-shadow: none;
		-webkit-box-shadow: none;
		box-shadow: none;
	}

	.lefttwo .el-menu-item {
		color: rgb(37, 177, 247) !important;
		padding-left: 44px !important;
	}

	.three_two span {
		margin-left: 34px !important;
	}
	.two_nav{
		color:rgb(37, 177, 247);
	}
</style>
